module.exports = __webpack_public_path__ + "img/aw.d185aaf0.svg";